import script from "./loan-disbursements-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./loan-disbursements-report-table.vue?vue&type=script&setup=true&lang=js"

import "./loan-disbursements-report-table.vue?vue&type=style&index=0&id=7a399650&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a399650"]])

export default __exports__